<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.enterpriseImageUrl.length!==0">
            <va-card
              overlay
              :image='insertData.enterpriseImageUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='实习背景图'>
              <va-file-upload
                type='single'
                v-model='insertData.enterpriseImage'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.enterpriseName"
              label="企业名称"
              removable
              :messages="message"
              :error="!!error.enterpriseNameErrors.length"
              :error-messages="error.enterpriseNameErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.enterpriseDescription"
              placeholder="公司介绍"
            ></vue-trix>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../api/upload'
import enterprisePracticeResourceApi from '../../api/enterprisePracticeResource'
import { copyObject } from '../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        enterpriseImage: [],
        enterpriseImageUrl: '',
        enterpriseName: '',
        enterpriseDescription: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        enterpriseNameErrors: [],
        enterpriseDescriptionErrors: [],
        sortNumErrors: [],
      },
      title: '新增企业实习资源',
      showId: false,
      submitButtonStatus: true,
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑企业实习资源'
      // 通过id获取详情
      enterprisePracticeResourceApi.getEnterprisePracticeResource(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.enterpriseNameErrors.length &&
          !this.error.enterpriseDescriptionErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.enterpriseImageUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        enterpriseImageUrl: this.insertData.enterpriseImageUrl,
        enterpriseName: this.insertData.enterpriseName,
        enterpriseDescription: this.insertData.enterpriseDescription,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        enterprisePracticeResourceApi.updateEnterprisePracticeResource(data.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'enterprisePracticeResource' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        enterprisePracticeResourceApi.saveEnterprisePracticeResource(data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'enterprisePracticeResource' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      }
    },
    uploadImage () {
      if (this.insertData.enterpriseImage.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.enterpriseImage[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.enterpriseImageUrl = response.url
      })
    },
    checkField () {
      this.error.enterpriseNameErrors = this.insertData.enterpriseName ? [] : ['enterpriseName is required']
      this.error.enterpriseDescriptionErrors = this.insertData.enterpriseDescription ? [] : ['enterpriseDescription is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
